module.exports = __webpack_public_path__ + "static/assets/193be3815628fb3d90d4d636a0e97f3a.svg";